import React from "react";
import { NavLink } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { LayoutGrid, Package, ShoppingBag, Mic, Settings2, Truck, GraduationCap } from "lucide-react";
import api from "@/lib/api";

const items = [
  { to: "/tableau-de-bord", icon: LayoutGrid, key: "home", id: "nav-home" },
  { to: "/stocks", icon: Package, key: "stocks", id: "nav-stocks" },
  { to: "/commandes", icon: ShoppingBag, key: "orders", id: "nav-orders" },
  { to: "/copilote", icon: Mic, key: "copilote", id: "nav-copilote", center: true },
  { to: "/livreurs", icon: Truck, key: "drivers", id: "nav-drivers", driversOnly: true },
  { to: "/transporteurs", icon: Truck, key: "carriers", id: "nav-carriers", carriersOnly: true },
  { to: "/conseils", icon: GraduationCap, key: "coaching", id: "nav-coaching" },
  { to: "/reglages", icon: Settings2, key: "settings", id: "nav-settings" },
];

export default function BottomNav() {
  const { t } = useTranslation();
  const { data: business } = useQuery({ queryKey: ["business"], queryFn: async () => (await api.get("/business")).data });
  const tourEnabled = !["CA", "FR"].includes(business?.country);
  const visible = items.filter((it) => !(it.driversOnly && !tourEnabled) && !(it.carriersOnly && tourEnabled));
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-[#E5E0D8] pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-lg mx-auto flex items-end justify-around px-1 pt-1.5">
        {visible.map((it) => {
          const Icon = it.icon;
          if (it.center) {
            return (
              <NavLink key={it.id} to={it.to} data-testid={it.id} className="flex flex-col items-center -mt-6 px-1">
                {({ isActive }) => (
                  <>
                    <span
                      className={`h-14 w-14 rounded-2xl flex items-center justify-center shadow-lg transition-transform active:scale-95 ${
                        isActive ? "bg-[#1B4332]" : "bg-[#E85D04]"
                      }`}
                    >
                      <Icon className="h-7 w-7 text-white" strokeWidth={2.4} />
                    </span>
                    <span className="text-[9px] font-semibold mt-1 text-[#5C574F]">{t(`nav.${it.key}`)}</span>
                  </>
                )}
              </NavLink>
            );
          }
          return (
            <NavLink key={it.id} to={it.to} data-testid={it.id} className="flex flex-col items-center gap-1 py-2 px-1 flex-1">
              {({ isActive }) => (
                <>
                  <Icon
                    className={`h-6 w-6 transition-colors ${isActive ? "text-[#E85D04]" : "text-[#9c968a]"}`}
                    strokeWidth={isActive ? 2.6 : 2}
                  />
                  <span className={`text-[9px] font-semibold whitespace-nowrap ${isActive ? "text-[#E85D04]" : "text-[#9c968a]"}`}>
                    {t(`nav.${it.key}`)}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
